import initializeApplication from './initialize';
import { lazy, useEffect } from 'react';
import PrimaryRouter from './primary-router/PrimaryRouter';

const Essentials = lazy(() => import('./Essentials'));

function Main() {
  useEffect(() => {
    initializeApplication();
  }, []);

  return (
    <>
      <Essentials />
      <PrimaryRouter />
    </>
  );
}

export default Main;
